import { Plugin, WorkspaceLeaf } from "obsidian";
import { MonacoEditorView, VIEW_TYPE_MONACO } from "./views/MonacoEditorView";

export default class MonacoCodeEditorPlugin extends Plugin {
  async onload() {
    console.log("MonacoCodeEditorPlugin loaded ✅");

    // Register view type
    this.registerView(
      VIEW_TYPE_MONACO,
      (leaf: WorkspaceLeaf) => new MonacoEditorView(leaf)
    );

    // Add ribbon button
    this.addRibbonIcon("code-2", "Open Monaco Code Editor", () => {
      this.activateView();
    });
  }

  async onunload() {
    this.app.workspace.detachLeavesOfType(VIEW_TYPE_MONACO);
  }

  async activateView() {
    const { workspace } = this.app;

    // Look for an existing leaf
    let leaf = workspace.getLeavesOfType(VIEW_TYPE_MONACO)[0];

    if (!leaf) {
      let rightLeaf =
        workspace.getRightLeaf(false) ?? workspace.getRightLeaf(true);

      if (!rightLeaf) {
        console.error("Could not create a workspace leaf for Monaco Editor");
        return;
      }

      leaf = rightLeaf;

      await leaf.setViewState({
        type: VIEW_TYPE_MONACO,
        active: true,
      });
    }

    workspace.revealLeaf(leaf);
  }
}